import { createTheme } from "@mui/material/styles";

export const Theme = createTheme({
    palette: {
        text: {
            light: '#212529',
            lighter: '#444'
        },
        secondary: {
            main: '#ff9800',
            contrastText: '#ffffff',
        },
        primary: {
            main: '#3C7894'
        }
    }
})